import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as moment from 'moment-timezone';
import {
  Grid,
  Paper,
  AppBar,
  Typography,
  Tabs,
  Tab,
  SnackbarContent,
  Snackbar,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import TabPanel from '../../../components/TabPanel';
import { withStyles } from '@material-ui/core/styles';
import PortalProfileUpdate from '../components/portalProfileUpdate';
import PatientApptRequest from '../components/patientApptRequest';
import PatientCancelAppt from '../components/patientCancelAppt';
import PatientUpcomingAppt from '../components/patientUpcomingAppt';
import PatientPastAppt from '../components/patientPastAppt';
import { withSnackbar } from 'notistack';
// import { updatePatient } from '../../../services/api';
import '../style.css';

const {
  standardizePhoneNumber,
} = require('../../../util/standardizePhoneNumber');

function PatientInfoRow(props) {
  const {
    patient,
    history,
    activeTab,
    setActivetab,
    setButtonName,
    buttonName,
    // setFamily,
    onUpdatePatient,
    providerInfo,
    classes: {
      root,
      profileHeader,
      title,
      editIcon,
      profileGridSection,
      profileGridSectionTitle,
      profileGridSectionText,
      marginBottomFourtyEight,
      loading,
    },
  } = props;

  const [editModeOn, setEditModeOn] = useState({});
  const [currentUser, setCurrentUser] = useState({});
  const [subscribedDate, setSubscribedDate] = useState('');
  const [paymentMessage, setPaymentMessage] = useState(false);
  const [tabPosition, setTabPosition] = useState(0);

  useEffect(() => {
    if (activeTab === true && buttonName === 'clickUpcomingApptButton') {
      setTabPosition(0);
    } else if (activeTab === true && buttonName === 'clickApptRequestButton') {
      setTabPosition(2);
    } else {
      setTabPosition(tabPosition);
    }
  }, [activeTab, buttonName]);

  const handleTabPosition = position => {
    setActivetab(false);
    setButtonName(null);
    setTabPosition(position);
    if (patient.patientNotification.ids.length > 0 && position === 2) {
      setTimeout(() => {
        props.markReadStatus(patient.patientNotification.ids);
      }, 2000);
    }
  };

  const now = new Date().getTime();
  const then = new Date(patient.birthdate).getTime();
  const isMinor = (now - then) / 1000 / 60 / 60 / 24 / 365 < 18;
  return (
    <>
      <div className="fullWidth">
        <div className={root} style={{ padding: '10px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={3}>
              <Paper>
                <Grid>
                  <header className="headerFontSize">
                    <AppBar position="static" className={profileHeader}>
                      <h1
                        className={title}
                        style={{ display: 'flex', paddingLeft: '7px' }}
                      >
                        {patient.firstName + ' ' + patient.lastName}

                        <EditIcon
                          onClick={() =>
                            setEditModeOn({
                              ...editModeOn,
                              [patient.id]: !editModeOn[patient.id],
                            })
                          }
                          className={editIcon}
                        />
                      </h1>
                    </AppBar>
                  </header>
                  {paymentMessage && (
                    <Snackbar
                      className="snackBar-content"
                      bodyStyle={{
                        height: '200',
                        width: '200',
                        flexGrow: '0',
                      }}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                      open={true}
                      autoHideDuration={5000}
                      onClose={() => setPaymentMessage(false)}
                    >
                      <SnackbarContent
                        style={{
                          backgroundColor: '#5cb85c',
                        }}
                        message={'✔ Thanks for your Payment'}
                      />
                    </Snackbar>
                    // <PaymentSuccessModal
                    //   openPaymentSuccessModal={paymentMessage}
                    //   onClose={() => setPaymentMessage(false)}
                    // />
                  )}
                </Grid>

                <div>
                  <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div
                        className={profileGridSection}
                        style={{ paddingLeft: '0px' }}
                      >
                        <h4 className={profileGridSectionTitle}>Name</h4>
                        <span className={profileGridSectionText}>
                          {patient && patient.firstName}{' '}
                          {patient && patient.lastName}
                        </span>
                      </div>
                    </Grid>

                    {!patient.isDependent && (
                      <>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div
                            className={profileGridSection}
                            style={{ paddingLeft: '0px' }}
                          >
                            <h4 className={profileGridSectionTitle}>Phone</h4>
                            <span className={profileGridSectionText}>
                              {standardizePhoneNumber(
                                patient && patient.phone
                              ) || '--'}
                            </span>
                          </div>
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <div
                            className={profileGridSection}
                            style={{ paddingLeft: '0px' }}
                          >
                            <h4 className={profileGridSectionTitle}>Email</h4>
                            <span className={profileGridSectionText}>
                              {patient && patient.email}
                            </span>
                          </div>
                        </Grid>
                      </>
                    )}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div
                        className={profileGridSection}
                        style={{ paddingLeft: '0px' }}
                      >
                        <h4 className={profileGridSectionTitle}>DOB</h4>
                        <span className={profileGridSectionText}>
                          {moment
                            .utc(patient && patient.birthdate)
                            .format('MM/DD/YYYY')}
                        </span>
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div
                        className={profileGridSection}
                        style={{ paddingLeft: '0px' }}
                      >
                        <h4 className={profileGridSectionTitle}>Sex</h4>
                        <span className={profileGridSectionText}>
                          {patient && patient.gender}
                        </span>
                      </div>
                    </Grid>

                    {!patient.isDependent && (
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <div
                          className={profileGridSection}
                          style={{ paddingLeft: '0px' }}
                        >
                          <h4 className={profileGridSectionTitle}>Zip Code</h4>
                          <span className={profileGridSectionText}>
                            {(patient && patient.zipcode) || '--'}
                          </span>
                        </div>
                      </Grid>
                    )}
                  </Grid>
                  {providerInfo &&
                  providerInfo.groupProvider &&
                  providerInfo.groupProvider.length > 0 ? (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <div
                        className={profileGridSection}
                        style={{ paddingLeft: '0px' }}
                      >
                        <h4 className={profileGridSectionTitle}>
                          Qwell Concierge Member Of
                        </h4>
                        <span className={profileGridSectionText}>
                          {providerInfo &&
                            providerInfo.groupProvider &&
                            providerInfo.groupProvider.map(providers => (
                              <span className={profileGridSectionText}>
                                {providers.fullTitle} <br /> <br />
                              </span>
                            ))}
                          {/* <Box fontWeight="fontWeightBold">
                                  Click to see more...
                                </Box> */}
                        </span>
                      </div>
                    </Grid>
                  ) : null}
                  {subscribedDate && subscribedDate.length > 0 ? (
                    <Grid item xs={12} sm={12} md={12} lg={8}>
                      <div className={profileGridSection}>
                        <h4 className={profileGridSectionTitle}>
                          Subscription End-Date
                        </h4>
                        {subscribedDate &&
                          subscribedDate.map(subInfo => (
                            <span className={profileGridSectionText}>
                              {subInfo && subInfo.subscriptionEnd}
                            </span>
                          ))}
                      </div>
                    </Grid>
                  ) : null}
                </div>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={9} style={{ zIndex: '0' }}>
              {/* {
              isMinor ||
              patient.isGuardian ||
              patient.userId === currentUser.id ? ( */}
              <>
                <div>
                  <Grid container className={marginBottomFourtyEight}>
                    <AppBar position="static" color="default">
                      <Tabs
                        value={tabPosition}
                        onChange={(e, position) => handleTabPosition(position)}
                      >
                        <Tab label="Upcoming Appointments" />
                        <Tab label="Past Appointments" />
                        <Tab label="Appointment Request" />
                        <Tab label="Cancelled Appointments" />
                      </Tabs>
                    </AppBar>
                    {tabPosition === 0 && (
                      <TabPanel>
                        <PatientUpcomingAppt
                          patientId={patient.id}
                          history={history}
                        />
                      </TabPanel>
                    )}
                    {tabPosition === 1 && (
                      <TabPanel>
                        <PatientPastAppt patientId={patient.id} />
                      </TabPanel>
                    )}
                    {tabPosition === 2 && (
                      <TabPanel>
                        <PatientApptRequest patientId={patient.id} />
                      </TabPanel>
                    )}
                    {tabPosition === 3 && (
                      <TabPanel>
                        <PatientCancelAppt patientId={patient.id} />
                      </TabPanel>
                    )}
                  </Grid>
                </div>
              </>
              {/* ) : (
                <Paper style={{ padding: '15px' }}>
                  <Typography>
                    This family member is over the age of 18, so Qwell cannot
                    show you their appointments. If you set their account up
                    please sign in using their email address.
                  </Typography>
                </Paper>
              )} */}
            </Grid>
          </Grid>
          {editModeOn[patient.id] && (
            <PortalProfileUpdate
              patient={patient}
              updatePatient={onUpdatePatient}
              // setFamily={setFamily}
              onClose={() => setEditModeOn({})}
            />
          )}
        </div>
      </div>
    </>
  );
}

const styles = theme => ({
  root: {
    padding: '10px 30px',
    marginLeft: '5em',
    marginRight: '5em',
    paddingTop: '2em',
    backgroundColor: '#f3f5f7',
    marginBottom: '2em',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0em',
      marginRight: '0em',
      paddingTop: '1em',
    },
  },
  profileHeader: {
    backgroundColor: '#0B294F',
  },
  marginBottomFourtyEight: {
    marginBottom: 48,
  },
  header: {
    backgroundColor: '#6193c5',
  },
  title: {
    fontWeight: 'normal',
    fontSize: '24px',
    lineHeight: '19px',
    color: 'white',
    paddingTop: '1em',
    paddingBottom: '1em',
    paddingLeft: '.7em',
  },
  editIcon: {
    fontSize: '20px',
    marginLeft: '10px',
  },
  profileGridSection: {
    paddingBottom: '15px',
    paddingLeft: '1.5em',
    paddingTop: '15px',
    overflowWrap: 'break-word',
  },
  profileGridSectionTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  profileGridSectionText: {
    color: '#1C2B39',
    fontWeight: '300',
    fontSize: '20px',
    lineHeight: '24px',
  },
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default withSnackbar(withStyles(styles)(PatientInfoRow));
